export const CONDOS = [
  {
    id: "FL-MIAMI-001",
    name: "Brickell City Tower",
    address: "1100 Brickell Bay Dr",
    city: "Miami", zip: "33131", neighborhood: "Brickell", county: "Miami-Dade",
    units: 312, year_built: 2008, status: "Current",
    managing_entity: "FirstService Residential", fiscal_year_end: "12/31",
    financials: { operating_revenue: 2840000, operating_expenses: 2710000, replacement_revenue: 620000, replacement_expenses: 180000, bad_debt: 42000, operating_fund_balance: 310000, replacement_fund_balance: 1240000 },
    special_assessment: null,
    complaints: [
      { year: 2022, type: "Election Dispute", status: "Resolved", description: "Board election procedures not followed per statute 718.112" },
      { year: 2023, type: "Financial Records Access", status: "Resolved", description: "Association denied owner access to financial records" },
    ],
    risk_score: 38, risk_label: "Low Risk", lat: 25.7617, lng: -80.1918,
  },
  {
    id: "FL-MIAMI-002",
    name: "Marquis Residences",
    address: "1100 Biscayne Blvd",
    city: "Miami", zip: "33132", neighborhood: "Edgewater", county: "Miami-Dade",
    units: 292, year_built: 2009, status: "Current",
    managing_entity: "Associa", fiscal_year_end: "12/31",
    financials: { operating_revenue: 2460000, operating_expenses: 2890000, replacement_revenue: 410000, replacement_expenses: 620000, bad_debt: 118000, operating_fund_balance: -112000, replacement_fund_balance: 290000 },
    special_assessment: { amount: 4200000, reason: "Structural repairs and facade restoration per SB 4-D", year: 2023, per_unit: 14383 },
    complaints: [
      { year: 2021, type: "Recall Dispute", status: "Resolved", description: "Board members improperly refused to certify recall petition" },
      { year: 2022, type: "Financial Records Access", status: "Resolved", description: "Repeated denial of owner requests for financial statements" },
      { year: 2022, type: "Special Assessment", status: "Resolved", description: "Special assessment levied without proper owner vote" },
      { year: 2023, type: "Election Dispute", status: "Resolved", description: "Proxy votes improperly counted in annual election" },
      { year: 2023, type: "Financial Records Access", status: "Open", description: "Replacement reserve fund audit findings not disclosed to owners" },
      { year: 2024, type: "Structural Safety", status: "Open", description: "Board failed to disclose engineering report findings within required timeframe" },
    ],
    risk_score: 81, risk_label: "High Risk", lat: 25.7785, lng: -80.1879,
  },
  {
    id: "FL-MIAMI-003",
    name: "Icon Brickell Tower I",
    address: "475 Brickell Ave",
    city: "Miami", zip: "33131", neighborhood: "Brickell", county: "Miami-Dade",
    units: 586, year_built: 2008, status: "Current",
    managing_entity: "KW Property Management", fiscal_year_end: "12/31",
    financials: { operating_revenue: 6120000, operating_expenses: 5840000, replacement_revenue: 1100000, replacement_expenses: 340000, bad_debt: 64000, operating_fund_balance: 892000, replacement_fund_balance: 3410000 },
    special_assessment: null,
    complaints: [
      { year: 2023, type: "Election Dispute", status: "Resolved", description: "Candidate eligibility improperly determined by board" },
    ],
    risk_score: 22, risk_label: "Low Risk", lat: 25.7598, lng: -80.1937,
  },
  {
    id: "FL-MIAMI-004",
    name: "Aria on the Bay",
    address: "1770 N Bayshore Dr",
    city: "Miami", zip: "33132", neighborhood: "Edgewater", county: "Miami-Dade",
    units: 647, year_built: 2017, status: "Current",
    managing_entity: "Greystar", fiscal_year_end: "12/31",
    financials: { operating_revenue: 5980000, operating_expenses: 5620000, replacement_revenue: 980000, replacement_expenses: 210000, bad_debt: 38000, operating_fund_balance: 740000, replacement_fund_balance: 2890000 },
    special_assessment: null,
    complaints: [],
    risk_score: 14, risk_label: "Low Risk", lat: 25.7842, lng: -80.1876,
  },
  {
    id: "FL-MIAMI-005",
    name: "The Crimson",
    address: "2101 Brickell Ave",
    city: "Miami", zip: "33129", neighborhood: "Brickell", county: "Miami-Dade",
    units: 88, year_built: 2005, status: "Current",
    managing_entity: "Self-Managed", fiscal_year_end: "09/30",
    financials: { operating_revenue: 748000, operating_expenses: 812000, replacement_revenue: 96000, replacement_expenses: 210000, bad_debt: 52000, operating_fund_balance: -98000, replacement_fund_balance: 84000 },
    special_assessment: { amount: 1100000, reason: "Pool deck, elevator, and roof replacement", year: 2024, per_unit: 12500 },
    complaints: [
      { year: 2020, type: "Financial Records Access", status: "Resolved", description: "Self-managed board refused third-party audit" },
      { year: 2021, type: "Election Dispute", status: "Resolved", description: "Annual meeting repeatedly cancelled" },
      { year: 2022, type: "Special Assessment", status: "Resolved", description: "Emergency assessment levied without required notice" },
      { year: 2023, type: "Financial Records Access", status: "Open", description: "Operating fund deficit not disclosed in budget" },
      { year: 2024, type: "Structural Safety", status: "Open", description: "Milestone inspection overdue per SB 4-D requirements" },
    ],
    risk_score: 91, risk_label: "High Risk", lat: 25.7512, lng: -80.1961,
  },
  {
    id: "FL-MIAMI-006",
    name: "Panorama Tower",
    address: "1100 S Miami Ave",
    city: "Miami", zip: "33130", neighborhood: "Brickell", county: "Miami-Dade",
    units: 821, year_built: 2018, status: "Current",
    managing_entity: "FirstService Residential", fiscal_year_end: "12/31",
    financials: { operating_revenue: 9240000, operating_expenses: 8710000, replacement_revenue: 1480000, replacement_expenses: 390000, bad_debt: 71000, operating_fund_balance: 1420000, replacement_fund_balance: 4820000 },
    special_assessment: null,
    complaints: [
      { year: 2022, type: "Election Dispute", status: "Resolved", description: "Ballot irregularities in board election" },
    ],
    risk_score: 19, risk_label: "Low Risk", lat: 25.7568, lng: -80.1939,
  },
  {
    id: "FL-MIAMI-007",
    name: "One Ocean South Beach",
    address: "1 Collins Ave",
    city: "Miami Beach", zip: "33139", neighborhood: "South Beach", county: "Miami-Dade",
    units: 240, year_built: 2004, status: "Current",
    managing_entity: "Cushman & Wakefield", fiscal_year_end: "12/31",
    financials: { operating_revenue: 4820000, operating_expenses: 4630000, replacement_revenue: 840000, replacement_expenses: 290000, bad_debt: 29000, operating_fund_balance: 620000, replacement_fund_balance: 2140000 },
    special_assessment: null,
    complaints: [
      { year: 2021, type: "Financial Records Access", status: "Resolved", description: "Reserve study not made available to owners" },
      { year: 2023, type: "Election Dispute", status: "Resolved", description: "Director term limits not enforced" },
    ],
    risk_score: 33, risk_label: "Low Risk", lat: 25.7784, lng: -80.1300,
  },
  {
    id: "FL-MIAMI-008",
    name: "Quantum on the Bay",
    address: "1900 N Bayshore Dr",
    city: "Miami", zip: "33132", neighborhood: "Edgewater", county: "Miami-Dade",
    units: 720, year_built: 2007, status: "Current",
    managing_entity: "Associa", fiscal_year_end: "12/31",
    financials: { operating_revenue: 6840000, operating_expenses: 7210000, replacement_revenue: 920000, replacement_expenses: 1840000, bad_debt: 148000, operating_fund_balance: -218000, replacement_fund_balance: 410000 },
    special_assessment: { amount: 8640000, reason: "40-year structural recertification repairs, waterproofing, mechanical systems", year: 2024, per_unit: 12000 },
    complaints: [
      { year: 2019, type: "Financial Records Access", status: "Resolved", description: "Budget not provided 30 days before fiscal year end" },
      { year: 2020, type: "Special Assessment", status: "Resolved", description: "Assessment levied without required owner approval" },
      { year: 2021, type: "Recall Dispute", status: "Resolved", description: "Board refused to hold special meeting" },
      { year: 2022, type: "Structural Safety", status: "Resolved", description: "40-year recertification not completed on schedule" },
      { year: 2023, type: "Financial Records Access", status: "Open", description: "Reserve fund balance misrepresented in annual budget" },
      { year: 2023, type: "Special Assessment", status: "Open", description: "Second special assessment levied within 12 months" },
      { year: 2024, type: "Structural Safety", status: "Open", description: "Milestone inspection report findings not disclosed" },
    ],
    risk_score: 88, risk_label: "High Risk", lat: 25.7863, lng: -80.1871,
  },
  {
    id: "FL-MIAMI-009",
    name: "Brickell Flatiron",
    address: "1000 Brickell Plaza",
    city: "Miami", zip: "33131", neighborhood: "Brickell", county: "Miami-Dade",
    units: 549, year_built: 2022, status: "Current",
    managing_entity: "KW Property Management", fiscal_year_end: "12/31",
    financials: { operating_revenue: 6320000, operating_expenses: 5980000, replacement_revenue: 1040000, replacement_expenses: 120000, bad_debt: 22000, operating_fund_balance: 980000, replacement_fund_balance: 2640000 },
    special_assessment: null,
    complaints: [],
    risk_score: 11, risk_label: "Low Risk", lat: 25.7621, lng: -80.1923,
  },
  {
    id: "FL-MIAMI-010",
    name: "Wynwood Lofts",
    address: "250 NW 24th St",
    city: "Miami", zip: "33127", neighborhood: "Wynwood", county: "Miami-Dade",
    units: 126, year_built: 2019, status: "Current",
    managing_entity: "Vesta Property Services", fiscal_year_end: "12/31",
    financials: { operating_revenue: 1240000, operating_expenses: 1180000, replacement_revenue: 210000, replacement_expenses: 48000, bad_debt: 18000, operating_fund_balance: 142000, replacement_fund_balance: 580000 },
    special_assessment: null,
    complaints: [
      { year: 2022, type: "Election Dispute", status: "Resolved", description: "Proxy voting procedures not followed" },
    ],
    risk_score: 27, risk_label: "Low Risk", lat: 25.8024, lng: -80.1994,
  },
  {
    id: "FL-MIAMI-011",
    name: "SLS Lux Brickell",
    address: "801 S Miami Ave",
    city: "Miami", zip: "33130", neighborhood: "Brickell", county: "Miami-Dade",
    units: 450, year_built: 2017, status: "Current",
    managing_entity: "FirstService Residential", fiscal_year_end: "12/31",
    financials: { operating_revenue: 5410000, operating_expenses: 5180000, replacement_revenue: 890000, replacement_expenses: 210000, bad_debt: 31000, operating_fund_balance: 680000, replacement_fund_balance: 2480000 },
    special_assessment: null,
    complaints: [
      { year: 2023, type: "Financial Records Access", status: "Resolved", description: "Vendor contracts not disclosed to owners upon request" },
    ],
    risk_score: 24, risk_label: "Low Risk", lat: 25.7582, lng: -80.1942,
  },
  {
    id: "FL-MIAMI-012",
    name: "Paraiso Bay",
    address: "600 NE 31st St",
    city: "Miami", zip: "33137", neighborhood: "Edgewater", county: "Miami-Dade",
    units: 391, year_built: 2018, status: "Current",
    managing_entity: "Greystar", fiscal_year_end: "12/31",
    financials: { operating_revenue: 4120000, operating_expenses: 4380000, replacement_revenue: 680000, replacement_expenses: 840000, bad_debt: 92000, operating_fund_balance: -184000, replacement_fund_balance: 310000 },
    special_assessment: { amount: 2800000, reason: "Parking structure waterproofing and lobby renovation", year: 2023, per_unit: 7160 },
    complaints: [
      { year: 2022, type: "Special Assessment", status: "Resolved", description: "Assessment amount not properly disclosed in advance" },
      { year: 2023, type: "Financial Records Access", status: "Open", description: "Operating deficit not reflected in proposed budget" },
      { year: 2023, type: "Election Dispute", status: "Resolved", description: "Candidate disqualified without proper hearing" },
    ],
    risk_score: 62, risk_label: "Medium Risk", lat: 25.8012, lng: -80.1843,
  },
  {
    id: "FL-MIAMI-013",
    name: "Coconut Grove Towers",
    address: "2899 McFarlane Rd",
    city: "Miami", zip: "33133", neighborhood: "Coconut Grove", county: "Miami-Dade",
    units: 168, year_built: 1998, status: "Current",
    managing_entity: "Self-Managed", fiscal_year_end: "06/30",
    financials: { operating_revenue: 1620000, operating_expenses: 1840000, replacement_revenue: 280000, replacement_expenses: 490000, bad_debt: 84000, operating_fund_balance: -312000, replacement_fund_balance: 142000 },
    special_assessment: { amount: 3360000, reason: "40-year recertification structural repairs, roof, and plumbing", year: 2022, per_unit: 20000 },
    complaints: [
      { year: 2018, type: "Structural Safety", status: "Resolved", description: "40-year inspection overdue by 3 years" },
      { year: 2019, type: "Financial Records Access", status: "Resolved", description: "Reserve fund study not updated in 8 years" },
      { year: 2020, type: "Special Assessment", status: "Resolved", description: "Emergency assessment without proper owner notice" },
      { year: 2021, type: "Recall Dispute", status: "Resolved", description: "Board refused to hold recalled member hearing" },
      { year: 2022, type: "Structural Safety", status: "Open", description: "Repair work delayed 18 months past recertification deadline" },
      { year: 2023, type: "Financial Records Access", status: "Open", description: "Contractor invoices for $1.2M not made available to owners" },
      { year: 2024, type: "Special Assessment", status: "Open", description: "Third special assessment in four years levied without vote" },
    ],
    risk_score: 95, risk_label: "High Risk", lat: 25.7280, lng: -80.2384,
  },
];

export const STATS = {
  total_condos: CONDOS.length,
  total_complaints: CONDOS.reduce((s, c) => s + c.complaints.length, 0),
  high_risk_count: CONDOS.filter(c => c.risk_score >= 70).length,
  medium_risk_count: CONDOS.filter(c => c.risk_score >= 40 && c.risk_score < 70).length,
  low_risk_count: CONDOS.filter(c => c.risk_score < 40).length,
  special_assessment_count: CONDOS.filter(c => c.special_assessment).length,
};
